import isEqual from 'lodash/isEqual'
import authTypes from 'constants/authTypes'

type ApiAction = import('types/api').ApiAction
type RootState = import('types/state').RootState

type MiddlewareStore = {
  getState: () => RootState
}

type NextFn = (action: ApiAction) => unknown

type QueueOnlyMiddleware = ((store: MiddlewareStore) => (next: NextFn) => (action: ApiAction) => unknown) & {
  setQueueOnlyOverride: (enabled: boolean | null) => void
  clearQueueOnlyOverride: () => void
}


const authTypeArrays = authTypes.map((a: { REQUEST: string; RECEIVE: string; FAIL: string }) => [a.REQUEST, a.RECEIVE, a.FAIL])
let queueOnlyOverride: boolean | null = null

type QueueOnlyWindow = Window & {
  __GT_QUEUE_ONLY_API__?: boolean
}

const setQueueOnlyOverride = (enabled: boolean | null) => {
  queueOnlyOverride = enabled
}

const clearQueueOnlyOverride = () => {
  queueOnlyOverride = null
}

const isQueueOnlyEnabled = () => {
  if (queueOnlyOverride != null) {
    return queueOnlyOverride
  }
  const windowRef = window as QueueOnlyWindow
  if (windowRef.__GT_QUEUE_ONLY_API__ === false) {
    return false
  }
  if (window?.localStorage != null) {
    const mode = window.localStorage.getItem('gt.queueOnlyApi')
    if (mode === 'true') {
      return true
    }
    if (mode === 'false') {
      return false
    }
  }
  return true
}

const middleware: QueueOnlyMiddleware = (_store: MiddlewareStore) => (next: NextFn) => (action: ApiAction) => {
  if (!isQueueOnlyEnabled()) {
    return next(action)
  }
  if (!(action.types && action.meta?.request)) {
    return next(action)
  }
  // if (!action.meta?.retry) {
  //   return next(action)
  // }
  if (authTypeArrays.some((t: string[]) => isEqual(t, action.types))) {
    return next(action)
  }

  action.meta.tempRequest = action.meta.request
  delete action.meta.request
  action.type = action.types[0]
  action.meta ??= {}
  action.meta.pending = true
  return Promise.resolve(next(action))
}

middleware.setQueueOnlyOverride = setQueueOnlyOverride
middleware.clearQueueOnlyOverride = clearQueueOnlyOverride

export default middleware
